import App from "../../app/indexDesktop";
import AsyncHome, { loadData as loadHomeData } from "../../pages/Home/Desktop";
import AsyncBaiduHome from "../../pages/BaiduHome/Desktop/index";
import AsyncPropertyPage, {
  loadData as loadPropertyData,
  PreFetchPropertyPage,
} from "../../pages/PropertyPage/Desktop";
import AsyncVideoPage, { loadData as loadVideoPageData } from "../../pages/VideoPage";
import AsyncSearch, { loadData as loadSeachData, PreFetchSearch } from "../../pages/Search/Desktop";
import AsyncNearby from "../../pages/Nearby";
import AsyncEssentialKit from "../../pages/EssentialKit";
import AsyncBookForm, { loadData as loadBookFormData, PreFetchBookForm } from "pages/BookForm";
import NotFound from "../../pages/NotFound";
import AsyncProfilePage from "../../pages/Profile/Desktop";
import AsyncBookingsPage from "../../pages/Bookings/Desktop";
import AsyncBookingsDetailsPage, {
  loadData as loadBookingDetailsData,
} from "../../pages/BookingDetails/Desktop";
import AsyncCashbackSupportPage from "../../pages/CashbackSupport";
import AsyncOffersPage from "../../pages/Offers/Desktop";
import AsyncPersonalInfoPage from "../../pages/ThirdPartyInfo/Desktop";
import AsyncBlogPostPage from "../../pages/Blog/BlogPost";
import AsyncBlogGridPage from "../../pages/Blog/BlogGrid";
import AsyncBlogHomePage from "../../pages/Blog/BlogHome";
import loadBlogData from "../../pages/Blog/data/loadData";
import { newsMiddlewareServer } from "@Pages/News/NewsPost/data/newsPageReducer";
import AsyncNewsHomePage from "../../pages/News/NewsHome";
import AsyncNewsGridPage from "../../pages/News/NewsGrid";
import AsyncNewsPostPage from "../../pages/News/NewsPost";
import loadNewsData from "../../pages/News/data/loadData";
import AsyncUniversityPage, {
  loadData as loadUniversityPageData,
} from "../../pages/UniversityPage/Desktop";
import AsyncAmberPlus, { loadData as loadAmberPlusData } from "../../pages/AmberPlus/Desktop";
import AsyncAmberPlusCross, {
  loadData as loadAmberPlusCrossData,
} from "../../pages/AmberPlusCross/Desktop";
import AsyncForexBooking from "../../pages/AmberPlusCrossForex";
import AsyncEsimPostPayment from "../../pages/EsimPostPayment";
import AsyncRentPayment, { loadData as loadRentPaymentData } from "../../pages/RentPayment";
import AsyncPayRentStatus from "../../pages/RentPayment/Status";
import AsyncAmberPlusCategories, {
  loadData as loadAmberPlusCategoriesData,
} from "../../pages/PlusCategories/Desktop";
import {
  appBannerMiddleware,
  authMiddlewareServer,
  dispatchCookies,
  dispatchMetaIndexTag,
  gridViewMiddleware,
  abTestMiddleware,
  chinaLanguageModalMiddleWare,
  translationMiddleWare,
  translationClientMiddleware,
  userCurrencyExchangeMiddleware,
} from "@App/appReducer";
import AsyncPaymentForm from "../../pages/Payment";
import AsyncPaymentFormSuccess from "../../pages/Payment/components/PaymentSuccess/index";
import AsyncCustomPayment from "../../pages/Payment/components/CustomPayment";
import AsyncReferralProgramPage from "../../pages/Referral/Desktop";
import AsyncProfileReferPage from "../../pages/ProfileRefer/Desktop";
import BookFromSuccess from "@Pages/BookForm/components/BookformSuccess";
import loadPaymentSuccessData from "@Pages/BookForm/data/loadPaymentSuccessData";
import AsyncShortlistPage from "../../pages/Shortlist/Desktop";
import AsyncSupportPage from "../../pages/Support";
import { whitelabelMiddlewareServer } from "@App/whiteLabelReducer";
import AsyncListPage from "../../pages/ListWithUsV2";
import AsyncTermsPage from "../../pages/TermsV2";
import AsyncGroupBookingPage from "../../pages/GroupBookingV2";
import AsyncPrivacyPage from "../../pages/PrivacyV2";
import loadCustomPaymentData from "@Pages/BookForm/data/leadCustomPaymentData";
import ApplicationForm from "@Pages/ApplicationForm";
import AsyncUserReviewScreen from "../../pages/UserReviewScreen";
import { blogMiddlewareServer } from "@Pages/Blog/BlogPost/data/blogPageReducer";
import AsyncAmberUserServiceAgreement from "../../pages/AmberUserServiceAgreement/Desktop";
import AsyncPersonalInfoSharingList from "../../pages/PersonalInfoSharingList/Desktop";
import AsyncAmberApp from "../../pages/AmberApp";
import AsyncSettingsPage from "../../pages/Settings";
import AsyncAboutPage from "../../pages/About";
import AsyncMediaMentionsPage from "../../pages/MediaMentionsV2";
import AsyncAmbassador from "../../pages/AmbassadorV2";
import AsyncScholarship from "../../pages/ScholarshipV2";
import AsyncExams from "../../pages/Exams";
import AsyncExamsPostPage, { loadData as loadExamsData } from "../../pages/Exams/ExamsPost";
import AsyncCareer from "../../pages/CareerV2";
import AsyncJobs from "../../pages/Jobs";
import AsyncPodcastPage from "../../pages/PodcastV2";
import AsyncContactPage from "../../pages/ContactUsV2";
import AsyncHowItWorksPage from "../../pages/HowItWorksV2";
import { APP_PAGE } from "@Utils/webApputils/analyticEvents";
import { iframeDetectionMiddlewareServer } from "@App/iframeReducer";
import LanguageFallbackRedirect from "@Utils/languageFallbackRedirect";
import { languageFromUrlMiddleware } from "@Utils/languageReduxHelpers";
import { withLang, SUPPORTED_LANGUAGES as SUPPORTED_LANG_VALUES } from "@Utils/languageCore";
import AsyncTranslationAdmin from "../../pages/TranslationAdmin";

const routesConfig = [
  {
    component: App,
    routes: [
      {
        path: withLang("/"),
        exact: true,
        component: AsyncHome,
        loadData: loadHomeData,
        moduleName: APP_PAGE.HOME,
        prefetch: [PreFetchPropertyPage, PreFetchSearch],
        tagforkey: ["home"],
        ssrSMaxAge: [14400, 14400],
        ssrStaleWhileRevalidate: [345600, 345600],
      },
      {
        path: "/index",
        exact: true,
        component: AsyncBaiduHome,
      },
      {
        path: withLang("/places/search/:id/agent-view"),
        redirect: true,
        redirectUrl: ({ id }: any) => `/places/search/${id}`,
        tagforkey: ["property", "search"],
      },
      {
        path: withLang("/nearby"),
        exact: true,
        component: AsyncNearby,
        moduleName: "NearbyPage",
        tagforkey: ["nearby"],
      },
      {
        path: ["/essential-kit/post-payment", "/:lang(es|de|fr)/essential-kit/post-payment"],
        exact: true,
        component: AsyncEssentialKit,
        moduleName: APP_PAGE.ESSENTIAL_KIT,
        tagforkey: ["essentialKit"],
      },
      {
        path: ["/essential-kit", "/:lang(es|de|fr)/essential-kit"],
        exact: true,
        redirect: true,
        redirectUrl: () => "/plus-cross/kit",
      },
      {
        path: ["/essential-kit/cart", "/:lang(es|de|fr)/essential-kit/cart"],
        exact: true,
        component: AsyncEssentialKit,
        moduleName: APP_PAGE.ESSENTIAL_KIT,
        tagforkey: ["essentialKit"],
      },
      {
        path: ["/essential-kit/:category", "/:lang(es|de|fr)/essential-kit/:category"],
        exact: true,
        component: AsyncEssentialKit,
        moduleName: APP_PAGE.ESSENTIAL_KIT,
        tagforkey: ["essentialKit"],
      },
      {
        path: [
          "/essential-kit/:category/:kitSlug",
          "/:lang(es|de|fr)/essential-kit/:category/:kitSlug",
        ],
        exact: true,
        component: AsyncEssentialKit,
        moduleName: APP_PAGE.ESSENTIAL_KIT,
        tagforkey: ["essentialKit"],
      },
      {
        path: withLang("/places/search/:id"),
        component: AsyncSearch,
        loadData: loadSeachData,
        moduleName: "SearchPage",
        tagforkey: ["search"],
        ssrSMaxAge: [20000, 172800],
        ssrStaleWhileRevalidate: [86400, 172800],
        ssrCacheQueryOverrides: [
          {
            when: { query: { p: { present: true } } },
            ssrStaleWhileRevalidate: 604800, // 7 days for paginated search
          },
        ],
      },
      {
        path: withLang("/places/:id/form"),
        loadData: loadBookFormData,
        component: AsyncBookForm,
        loadClarity: true,
        tagforkey: ["bookform"],
      },
      {
        path: withLang("/places/:id/application"),
        loadData: loadBookFormData,
        component: ApplicationForm,
        loadClarity: true,
        tagforkey: ["bookform"],
      },
      {
        path: withLang("/forms/submit"),
        loadData: loadPaymentSuccessData,
        component: BookFromSuccess,
        tagforkey: ["bookform"],
      },
      {
        path: withLang("/places/:id/payment"),
        loadData: loadBookFormData,
        component: AsyncPaymentForm,
        loadClarity: true,
        tagforkey: ["payment", "bookform"],
      },
      {
        path: withLang("/payments/complete"),
        loadData: loadPaymentSuccessData,
        component: AsyncPaymentFormSuccess,
        tagforkey: ["payment"],
      },
      {
        path: withLang("/payments/:token"),
        loadData: loadCustomPaymentData,
        component: AsyncCustomPayment,
        tagforkey: ["payment"],
      },
      {
        path: withLang("/places/:id/agent-view"),
        redirect: true,
        redirectUrl: ({ id }: any) => `/places/${id}`,
        tagforkey: ["property"],
      },
      {
        path: withLang("/places/:id/video/:videoId", "/places/:id/video"),
        loadData: loadVideoPageData,
        component: AsyncVideoPage,
        tagforkey: ["property"],
      },
      {
        path: withLang("/places/:id"),
        loadData: loadPropertyData,
        component: AsyncPropertyPage,
        prefetch: [PreFetchBookForm],
        tagforkey: ["property"],
        ssrSMaxAge: [15000, 172800],
        ssrStaleWhileRevalidate: [172800, 172800],
      },
      {
        path: withLang("/profile/shortlist"),
        exact: true,
        component: AsyncShortlistPage,
        tagforkey: ["shortlist"],
      },
      {
        path: withLang("/profile/offers"),
        exact: true,
        component: AsyncOffersPage,
        tagforkey: ["offers"],
      },
      {
        path: "/third-party-personal-info",
        exact: true,
        component: AsyncPersonalInfoPage,
      },
      {
        path: withLang("/profile/refer"),
        exact: true,
        component: AsyncProfileReferPage,
        tagforkey: ["referral"],
      },
      {
        path: "/plus/service/&isWebView=true",
        exact: true,
        component: AsyncAmberPlus,
        loadData: loadAmberPlusData,
        redirect: true,
      },
      {
        path: "/plus",
        exact: true,
        component: AsyncAmberPlus,
        loadData: loadAmberPlusData,
      },
      {
        path: withLang("/plus-cross/esim/post-payment"),
        exact: true,
        component: AsyncEsimPostPayment,
        moduleName: APP_PAGE.AMBER_PLUS,
        tagforkey: ["pluscross"],
      },
      {
        path: withLang("/plus-cross/forex/book"),
        exact: true,
        component: AsyncForexBooking,
        tagforkey: ["pluscross"],
      },
      {
        path: withLang("/plus-cross", "/plus-cross/:service"),
        exact: true,
        component: AsyncAmberPlusCross,
        loadData: loadAmberPlusCrossData,
        tagforkey: ["pluscross"],
      },
      {
        path: "/plus/service/:id",
        exact: true,
        component: AsyncAmberPlusCategories,
        loadData: loadAmberPlusCategoriesData,
      },
      {
        path: withLang("/referral-programme"),
        exact: true,
        component: AsyncReferralProgramPage,
        tagforkey: ["referral", "home"],
      },
      {
        path: withLang("/profile"),
        exact: true,
        component: AsyncProfilePage,
        tagforkey: ["profile"],
      },
      {
        path: withLang("/profile/leads"),
        exact: true,
        component: AsyncBookingsPage,
        tagforkey: ["bookings"],
      },
      {
        path: withLang("/profile/leads/:id"),
        exact: true,
        component: AsyncBookingsDetailsPage,
        loadData: loadBookingDetailsData,
        tagforkey: ["bookings"],
      },
      {
        path: withLang("/profile/leads/:id/pay-rent"),
        exact: true,
        component: AsyncRentPayment,
        loadData: loadRentPaymentData,
        tagforkey: ["bookings"],
      },
      {
        path: withLang("/booking/pay-rent/status"),
        exact: true,
        component: AsyncPayRentStatus,
        tagforkey: ["bookings"],
      },
      {
        path: withLang("/profile/support"),
        exact: true,
        component: AsyncSupportPage,
        tagforkey: ["generic"],
      },
      {
        path: withLang("/profile/leads/support"),
        exact: true,
        component: AsyncCashbackSupportPage,
        tagforkey: ["generic"],
      },
      {
        path: withLang("/profile/review/upload/:inventoryId(\\d+)"),
        exact: true,
        component: AsyncUserReviewScreen,
        tagforkey: ["generic"],
      },
      {
        path: withLang("/list"),
        exact: true,
        component: AsyncListPage,
        tagforkey: ["generic", "list"],
        indexable: true,
      },
      {
        path: "/amberapp",
        exact: true,
        component: AsyncAmberApp,
      },
      {
        path: "/about",
        exact: true,
        component: AsyncAboutPage,
        tagforkey: ["about"],
        indexable: true,
      },
      {
        path: withLang("/media"),
        exact: true,
        component: AsyncMediaMentionsPage,
        tagforkey: ["media"],
        indexable: true,
      },
      {
        path: "/amber-user-service-agreement",
        exact: true,
        component: AsyncAmberUserServiceAgreement,
      },
      {
        // `withLang`, like every other v2 route: without it `/de/podcast` still matched some
        // route and rendered, but with no language applied — every string, footer included,
        // stayed English.
        path: withLang("/podcast"),
        exact: true,
        component: AsyncPodcastPage,
        tagforkey: ["podcast", "ambassador"],
        indexable: true,
      },
      {
        path: withLang("/contact"),
        exact: true,
        component: AsyncContactPage,
        tagforkey: ["contact"],
        indexable: true,
      },
      {
        path: withLang("/how-it-works"),
        exact: true,
        component: AsyncHowItWorksPage,
        tagforkey: ["generic", "home", "howitworks"],
        indexable: true,
      },
      {
        path: withLang("/terms"),
        exact: true,
        component: AsyncTermsPage,
        tagforkey: ["terms"],
        indexable: true,
      },
      {
        path: withLang("/group-booking"),
        exact: true,
        component: AsyncGroupBookingPage,
        tagforkey: ["group-booking"],
        indexable: true,
      },
      {
        path: "/personal-info-sharing-list",
        exact: true,
        component: AsyncPersonalInfoSharingList,
      },
      {
        path: withLang("/privacy"),
        exact: true,
        component: AsyncPrivacyPage,
        tagforkey: ["privacy"],
        indexable: true,
      },
      {
        path: withLang("/blog"),
        exact: true,
        component: AsyncBlogHomePage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_HOME,
        ssrSMaxAge: 43200,
        tagforkey: ["blog"],
      },
      {
        path: withLang("/blog/latest"),
        exact: true,
        component: AsyncBlogGridPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_GRID,
        tagforkey: ["blog"],
      },
      {
        path: withLang("/blog/post/:slug"),
        exact: true,
        component: AsyncBlogPostPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_POST,
        tagforkey: ["blog"],
      },
      {
        path: withLang("/blog/category/:slug"),
        exact: true,
        component: AsyncBlogGridPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_CATEGORY,
        tagforkey: ["blog"],
      },
      {
        path: withLang("/blog/tag/:slug"),
        exact: true,
        component: AsyncBlogGridPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_TAG,
        tagforkey: ["blog"],
      },
      {
        path: withLang("/blog/search"),
        exact: true,
        component: AsyncBlogGridPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_SEARCH,
        tagforkey: ["blog"],
      },
      {
        path: "/drafts-blog/post/:slug",
        exact: true,
        component: AsyncBlogPostPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_DRAFTS,
      },
      {
        path: "/news",
        exact: true,
        component: AsyncNewsHomePage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_HOME,
        tagforkey: ["news"],
        ssrSMaxAge: 43200,
      },
      {
        path: "/news/latest",
        exact: true,
        component: AsyncNewsGridPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_GRID,
        tagforkey: ["news"],
      },
      {
        path: "/news/post/:slug",
        exact: true,
        component: AsyncNewsPostPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_POST,
        tagforkey: ["news"],
      },
      {
        path: "/news/amberreport/:slug",
        exact: true,
        component: AsyncNewsPostPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_AMBER_REPORT,
        tagforkey: ["news"],
      },
      {
        path: "/news/amberradar/:slug",
        exact: true,
        component: AsyncNewsPostPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_AMBER_RADAR,
      },
      {
        // Legacy path — kept so old amberbeat URLs match a route and trigger the redirect middleware
        path: "/news/amberbeat/:slug",
        exact: true,
        component: AsyncNewsPostPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_AMBER_RADAR,
        tagforkey: ["news"],
      },
      {
        path: "/news/category/:slug",
        exact: true,
        component: AsyncNewsGridPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_CATEGORY,
        tagforkey: ["news"],
      },
      {
        path: "/news/tag/:slug",
        exact: true,
        component: AsyncNewsGridPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_TAG,
        tagforkey: ["news"],
      },
      {
        path: "/news/search",
        exact: true,
        component: AsyncNewsGridPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_SEARCH,
        tagforkey: ["news"],
      },
      {
        path: withLang("/ambassador"),
        exact: true,
        component: AsyncAmbassador,
        tagforkey: ["ambassador"],
      },
      {
        path: "/exams",
        exact: true,
        component: AsyncExams,
        moduleName: APP_PAGE.EXAMS,
      },
      {
        path: "/exams/:examName/:slug",
        exact: true,
        component: AsyncExamsPostPage,
        loadData: loadExamsData,
        moduleName: APP_PAGE.EXAMS,
      },
      {
        path: "/drafts-exams/:examName/:slug",
        exact: true,
        component: AsyncExamsPostPage,
        loadData: loadExamsData,
        moduleName: APP_PAGE.EXAMS,
      },
      {
        path: withLang("/scholarship"),
        exact: true,
        component: AsyncScholarship,
        moduleName: APP_PAGE.SCHOLARSHIP,
        tagforkey: ["generic", "scholarship"],
        indexable: true,
      },
      {
        path: withLang("/career"),
        exact: true,
        component: AsyncCareer,
        tagforkey: ["career"],
        indexable: true,
      },
      {
        path: "/job-opening",
        exact: true,
        component: AsyncJobs,
        tagforkey: ["jobs"],
      },
      {
        path: "/universitypage/:slug",
        exact: true,
        component: AsyncUniversityPage,
        loadData: loadUniversityPageData,
      },
      {
        path: "/profile/settings",
        exact: true,
        component: AsyncSettingsPage,
        moduleName: APP_PAGE.SETTINGS,
      },
      ...(__DEV__
        ? [
            {
              path: "/admin/translations",
              exact: true,
              component: AsyncTranslationAdmin,
            },
          ]
        : []),
      // Language fallback redirect - catches invalid language routes
      {
        path: `/:lang(${SUPPORTED_LANG_VALUES.join("|")})/*`,
        component: LanguageFallbackRedirect,
      },
      {
        component: NotFound,
      },
    ],
    rootData: (props: any) => [
      languageFromUrlMiddleware(props), // Must run first to set language from URL
      authMiddlewareServer(props),
      appBannerMiddleware(props),
      dispatchCookies(props),
      dispatchMetaIndexTag(props),
      gridViewMiddleware(props),
      abTestMiddleware(props),
      chinaLanguageModalMiddleWare(props),
      translationMiddleWare(props),
      translationClientMiddleware(props),
      userCurrencyExchangeMiddleware(props),
    ],
    preFetchData: (props: any) => [
      whitelabelMiddlewareServer(props),
      blogMiddlewareServer(props),
      newsMiddlewareServer(props),
      iframeDetectionMiddlewareServer(props),
    ],
  },
] as any;

export default routesConfig;
